import React from "react";


const NotFoundPage = () => {



    return (
        <div className="notFound">
            <div className="content">
                <h1 className="text-center">404</h1>
                <h2 className="text-center">Üzgünüz</h2>
                <p className="text-center">Aradığınız içerik bulunamadı.</p>
            </div>
        </div>
    );
}
export default NotFoundPage;